import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import MarkDown from 'react-markdown';
import { map } from 'lodash';

// Utils
import tsRest from 'ts-rest-client';

import TranslateManager from 'ts-translate-js';
const tr = TranslateManager.boundTR;


interface WhereToBuyProps {
    whereToBuyRestUrl: string;
    integ: string;
    onContentChange: () => void;
}

interface WhereToBuyState {
    whereToBuyInfo: any;
    overrideContactInfo: string;
}

export const WhereToBuy = createClass<WhereToBuyProps, WhereToBuyState>({
    displayName: "WhereToBuy",

    propTypes:{
        whereToBuyRestUrl: PropTypes.string,
        integ: PropTypes.string,
        onContentChange: PropTypes.func
    },

    getInitialState() { return { whereToBuyInfo: null, overrideContactInfo: "" }; },


    componentDidMount(){
        // Initial ajax call here
        this.loadOverrideContactInfo();
        this.raiseContentChanged();
    },


    componentDidUpdate() {
        this.raiseContentChanged();
    },

    componentWillUnmount() {
        if(this.contactRequest) this.contactRequest.abort();
        if(this.overrideContactInfoRequest) this.overrideContactInfoRequest.abort();
    },

    loadWhereToBuyInfo() {
        this.contactRequest = tsRest.get(this.props.whereToBuyRestUrl);

        this.contactRequest.done(function(whereToBuyInfo) {
            this.setState({ whereToBuyInfo: whereToBuyInfo });
        }.bind(this));
    },

    loadOverrideContactInfo() {
        this.overrideContactInfoRequest = tsRest.get("/integration/" + this.props.integ + "/overridecontactinfo");
        this.overrideContactInfoRequest.done((data) => this.loadOverrideContactInfo_Success(data)); 
    },

    loadOverrideContactInfo_Success(overrideContactInfo) {
        
        if(overrideContactInfo == "")
            this.loadWhereToBuyInfo();
        
        this.setState({ overrideContactInfo: overrideContactInfo });
    },
    
    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    },

    render: function(){
        let ctl;

        if(this.state.overrideContactInfo != undefined && this.state.overrideContactInfo != "") {
            if(this.state.overrideContactInfo == "NONE")
                ctl = <div></div>;
            else
                ctl = (
                    <ul className="list-inline">
                        <li>
                            <MarkDown source={this.state.overrideContactInfo}></MarkDown>
                        </li>
                    </ul>
                );
        } else if(this.state.whereToBuyInfo != null){
            let posCtls;
            
            if(this.state.whereToBuyInfo.pos.length == 1)
                posCtls = (
                    <li>
                        <span>{tr("program.contactus.attheboxoffice")}</span> <span><strong>{this.state.whereToBuyInfo.pos[0].address}</strong></span>
                    </li>
                );
            else if(this.state.whereToBuyInfo.pos.length > 1) {
                posCtls = map(this.state.whereToBuyInfo.pos, (pos, i) => {
                    return (
                        <li key={i}>
                            <span>{pos.placeName}{tr(":")}<strong>{pos.address}, {pos.city}</strong></span>
                        </li>
                    );
                });
                //posCtls.unshift(<span key="or"> ou </span>);
            }

            ctl = (
                <ul className="list-inline">
                    <li>
                        <span>{tr("program.contactus.purschasebyphone")}</span> <span><strong>{this.state.whereToBuyInfo.phone}</strong></span>
                    </li>
                    {posCtls}
                </ul>
            );
        } else
            ctl = <div></div>;

        return (
            ctl
        );
    },

});
